import React, { useState, useEffect } from 'react';
import update from 'immutability-helper';

import Appearance from 'styles/Appearance.js';
import PageControl from 'views/PageControl.js';
import UserLookupField from 'views/UserLookupField.js';
import Views from 'views/Main.js';

const MultipleUserLookupField = ({ onChange, levels, restrictToDealership, restrictToGenealogy, rightContent, users, utils }) => {

    const limit = 5
    const [offset, setOffset] = useState(0);
    const [paging, setPaging] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState(users || []);

    const onAddUser = user => {

        // prevent moving forward if no user was provided
        if(!user) {
            return;
        }

        // update state with new selections
        let next = update(selectedUsers, { $push: [user] });
        setSelectedUsers(next);

        // notify subscribers of data change
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const onRemoveUser = (index, e) => {

        // stop click event from propagating to parent
        e.stopPropagation();

        // update state with new selections
        let next = update(selectedUsers, {
            $splice: [[
                index, 1
            ]]
        });
        setSelectedUsers(next)

        // notify subscribers of data change
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const getUsers = () => {
        return selectedUsers.filter((_, index) => {
            if(!paging) {
                return true;
            }
            return index >= offset && index < (offset + limit);
        }).sort((a,b) => {
            if(!a.last_name || !b.last_name) {
                return -1;
            }
            if(a.last_name === b.last_name) {
                return a.first_name.localeCompare(b.first_name);
            }
            return a.last_name.localeCompare(b.last_name);
        })
    }

    useEffect(() => {
        setPaging(selectedUsers && {
            total: selectedUsers.length,
            current_page: parseInt(offset / limit) + 1,
            number_of_pages: selectedUsers.length > limit ? Math.ceil(selectedUsers.length / limit) : 1
        });
    }, [offset, selectedUsers]);

    useEffect(() => {
        setSelectedUsers(users || []);
    }, [users]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }}>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                width: '100%'
            }}>
                <UserLookupField
                containerStyle={{ flexGrow: 1 }}
                icon={'users'}
                levels={levels}
                onChange={onAddUser}
                preserveResult={false}
                placeholder={'Search by first or last name...'}
                restrictToDealership={restrictToDealership}
                restrictToGenealogy={restrictToGenealogy}
                utils={utils} />
                {rightContent}
            </div>
            {selectedUsers.length > 0 && (
                <div 
                className={'custom-scrollbars'}
                style={{
                    ...Appearance.styles.unstyledPanel(),
                    marginTop: 8,
                    maxHeight: 750,
                    textAlign: 'left',
                    width: '100%'
                }}>
                    {getUsers().map((user, index, users) => {
                        return (
                            Views.entry({
                                bottomBorder: index !== users.length - 1,
                                icon: {
                                    path: user.avatar
                                },
                                key: index,
                                lastItem: index === users.length - 1,
                                rightContent: (
                                    <img
                                    className={'text-button'}
                                    src={'images/red-x-icon.png'}
                                    onClick={onRemoveUser.bind(this, index)}
                                    style={{
                                        width: 20,
                                        height: 20,
                                        objectFit: 'contain',
                                        marginLeft: 8
                                    }} />
                                ),
                                subTitle: user.phone_number,
                                title: user.full_name
                            })
                        )
                    })}
                    {paging && (
                        <PageControl
                        data={paging}
                        limit={limit}
                        offset={offset}
                        onClick={setOffset} />
                    )}
                </div>
            )}
        </div>
    )
}

export default MultipleUserLookupField;
